import { RECIPE_IMAGEFLUX_BASE_URL_MAP } from '@shared/app/constants/imagefluxBaseUrlMap';
import type { AppEnv } from '@shared/app/types/AppEnv';
import { createAuthorProfileImageKey } from '@shared/app/utils/createRecipeS3ImageKey';
import { createImageFluxUrl } from '@shared/app/utils/createImageFluxUrl';
import { useRuntimeConfig } from '#imports';

export function useAuthorImageUrl() {
  const APP_ENV = useRuntimeConfig().public.APP_ENV as AppEnv;

  const imageFluxBaseUrl = (() => {
    switch (APP_ENV) {
      case 'production':
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.production;
      case 'staging':
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.staging;
      default:
        return RECIPE_IMAGEFLUX_BASE_URL_MAP.local;
    }
  })();

  function createAuthorImageUrl({
    w,
    h,
    filename,
    authorId,
  }: {
    w?: number;
    h?: number;
    filename: string;
    authorId: number;
  }) {
    const path = createAuthorProfileImageKey(authorId, filename);
    return createImageFluxUrl(imageFluxBaseUrl, { w, h, path });
  }

  return {
    createAuthorImageUrl,
  };
}
